import { authApi } from '../api';

export const authRepo = {
    login: (credentials) => authApi.login(credentials),
    register: (data) => authApi.register(data),
    logout: () => authApi.logout(),
    me: () => authApi.me(),
    refresh: () => authApi.refresh(),
    changePassword: (data) => authApi.changePassword(data),
    forgotPassword: (data) => authApi.forgotPassword(data),
    verifyOtp: (data) => authApi.verifyOtp(data),
    resetPassword: (data) => authApi.resetPassword(data),
};